<template>
	<div class="pa-6 ao-form-footer">
		<template v-if="saveAndContinueBtn">
			<slot name="saveAndContinueBtn">
				<v-menu
					v-model="menu"
					location="bottom"
					:close-on-content-click="true"
				>
					<template v-slot:activator="{ props }">
						<ao-btn
							color="primary"
							class="mr-6"
							:loading="loading"
							@click="onSubmit(SUBMIT_TYPES.SAVE_AND_CLOSE)"
						>
							{{ $t('Save') }}
							<ao-icon
								v-bind="props"
								class="ml-2 ao-h1"
								iconName="angleDown"
							/>
						</ao-btn>
					</template>
					<v-card
						width="203"
						class="pa-2 mt-1"
					>
						<ao-btn
							color="primary"
							variant="flat"
							class="w-100 mb-2"
							@click="onSubmit(SUBMIT_TYPES.SAVE_AND_CLOSE)"
						>
							{{ $t('Save') }}
						</ao-btn>
						<ao-btn
							class="w-100"
							color="secondary"
							variant="flat"
							@click="onSubmit(SUBMIT_TYPES.SAVE_AND_CONTINUE)"
						>
							{{ $t('Save and continue') }}
						</ao-btn>
					</v-card>
				</v-menu>
			</slot>
		</template>
		<v-menu
			v-else-if="saveAddCloseAndNewBtn"
			v-model="menuSaveAddCloseAndNewBtn"
			:close-on-content-click="true"
		>
			<template v-slot:activator="{ props }">
				<ao-btn
					color="primary"
					class="mr-6"
					:loading="loading"
					@click="onSubmit(SUBMIT_TYPES.SAVE_AND_CONTINUE)"
				>
					{{ $t('Save and add') }}
					<ao-icon
						v-bind="props"
						class="ml-2 ao-h1"
						iconName="angleDown"
					/>
				</ao-btn>
			</template>
			<v-card
				width="203"
				class="pa-2 mt-1"
			>
				<ao-btn
					class="w-100 mb-2"
					color="primary"
					variant="flat"
					@click="onSubmit(SUBMIT_TYPES.SAVE_AND_CONTINUE)"
				>
					{{ $t('Save and add') }}
				</ao-btn>
				<ao-btn
					color="secondary"
					variant="flat"
					class="w-100 mb-2"
					@click="onSubmit(SUBMIT_TYPES.SAVE_AND_CLOSE)"
				>
					{{ $t('Save and close') }}
				</ao-btn>
				<ao-btn
					class="w-100"
					color="secondary"
					variant="flat"
					@click="onSubmit(SUBMIT_TYPES.CREATE_NEW)"
				>
					{{ $t('Create new') }}
				</ao-btn>
			</v-card>
		</v-menu>
		<ao-btn
			v-else-if="continueBtn"
			color="primary"
			class="mr-6"
			:loading="loading"
			@click="onSubmit(SUBMIT_TYPES.SAVE_AND_CLOSE)"
		>
			{{ $t('Continue') }}
		</ao-btn>
		<ao-btn
			v-else
			color="primary"
			class="mr-6"
			:loading="loading"
			@click="onSubmit(SUBMIT_TYPES.SAVE_AND_CLOSE)"
		>
			<slot name="submitBtnTitle">
				{{ $t('Save') }}
			</slot>
		</ao-btn>

		<slot name="additional-buttons"></slot>

		<ao-btn
			variant="text"
			@click="onCancel"
		>
			{{ $t('Cancel') }}
		</ao-btn>
	</div>
</template>
<script>
const SUBMIT_TYPES = {
	SAVE_AND_CONTINUE: 'submit:save-and-continue',
	SAVE_AND_CLOSE: 'submit:save-and-close',
	CREATE_NEW: 'submit:create-new',
}
export default {
	name: 'FormFooter',
	props: {
		saveAndContinueBtn: {
			type: Boolean,
		},
		saveAddCloseAndNewBtn: {
			type: Boolean,
		},
		continueBtn: {
			type: Boolean,
		},
		loading: {
			type: Boolean,
		},
	},
	emits: [
		'cancel',
		SUBMIT_TYPES.SAVE_AND_CONTINUE,
		SUBMIT_TYPES.SAVE_AND_CLOSE,
		SUBMIT_TYPES.CREATE_NEW,
	],
	data() {
		return {
			menu: false,
			menuSaveAddCloseAndNewBtn: false,
			SUBMIT_TYPES,
		}
	},
	methods: {
		onSubmit(emitName) {
			if (!Object.values(SUBMIT_TYPES).includes(emitName)) {
				throw new Error(`Unknown submit type: ${emitName}`)
			}

			this.$emit(emitName)
		},
		onCancel() {
			this.$emit('cancel')
		},
	},
}
</script>

<style lang="scss">
.ao-form-footer {
	background: #e6eef3;
	margin-top: auto;
}
</style>
